


















































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import store from 'src/assets/store'
import TopMenu from 'src/components/presenter/layout/TopMenu.vue'
import ActivityDashboard from 'components/presenter/layout/ActivityDashboard.vue'
import MenuButtonBack from 'src/components/presenter/layout/MenuButtonBack.vue'
import ItemMenu from 'src/components/presenter/layout/ItemMenu.vue'
import PullAndScroll from 'components/PullAndScroll.vue'
import NameEditor from 'components/presenter/item/NameEditor.vue'
import api from 'src/assets/api/gql'
import ItemGet from 'src/graphql/item/ItemGet.gql'
import ActivityDashboardQuery from 'src/graphql/person/ActivityDashboard.gql'
import { ItemType, Session, ForumTopic } from 'src/graphql/types'

@Component({
  components: {
    TopMenu,
    ActivityDashboard,
    MenuButtonBack,
    ItemMenu,
    PullAndScroll,
    NameEditor
  }
})
export default class LayoutsPresenterItem extends Vue {
  ItemType = ItemType
  state = store.state
  top = true
  rightDrawerShowing = false
  loaderDisable = false

  @Ref()
  readonly viewport!: PullAndScroll

  @Ref()
  readonly subpage!: PullAndScroll

  get item () {
    return store.state.presenter.item
  }

  created () {
    store.setProfile('PRESENTER')
  }

  @Watch('$route')
  navigation (next: Route, prev: Route) {
    if (next.params.id !== prev.params.id) {
      this.viewport.refresh(() => {})
    } else {
      this.$nextTick(async () => {
        await this.subpage.refresh(() => {})
        this.reload()
      })
    }
  }

  reload () {
    // console.log('RELOAD')
    this.$nextTick(() => {
      this.viewport.loader.resume()
      this.viewport.loader.poll()
    })
  }

  async refresh (done: () => void) {
    // console.log('REFERSH 1')
    const { data } = await api.query({
      query: ItemGet,
      variables: {
        id: +this.$route.params.id
      }
    })
    if (data.item) {
      store.presenterInit(data.item)
      // console.log('REFERSH 2')
      this.$nextTick(async () => {
        // console.log('REFERSH 3')
        await this.subpage.refresh(done)
      })
    } else {
      this.$router.replace('/presenter/')
    }
  }

  async load (index: number, done: (stop?: boolean) => void) {
    // console.log('LOAD')
    await this.subpage.load(index, done)
  }

  async activityLoad () {
    const { data: { sessionsRecent: { nodes: sessions }, forumTopicsRecent: { nodes: forumTopics } } } = await api.query({
      query: ActivityDashboardQuery,
      variables: { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone }
    })
    return { sessions, forumTopics }
  }

  activitySessionUrl (session: Session) {
    return `/presenter/session/${session.id}`
  }

  activityForumTopicUrl (forumTopic: ForumTopic) {
    return `/presenter/${forumTopic.courseId}/forum/${forumTopic.id}`
  }
}

